import firebase from "firebase/app";
import "firebase/messaging";
import axios from "axios";
import getSecret from "./helpers/get-secret";
const serverUrl = getSecret("SERVER_URL");

const firebaseConfig = {
  apiKey: "AIzaSyBzf9fCCpMDgOkEU2x-YVsyMx_wzRI2Gag",
  authDomain: "proyect0-381301.firebaseapp.com",
  projectId: "proyect0-381301",
  storageBucket: "proyect0-381301.appspot.com",
  messagingSenderId: "91226073274",
  appId: "1:91226073274:web:0ec9240e49da8e8f3cba83",
  measurementId: "G-3P2FQSHY9T",
};

firebase.initializeApp(firebaseConfig);

const messaging = firebase.messaging();

let validate = false;

// Función para obtener el token de FCM
function getFCMToken() {
  return new Promise((resolve, reject) => {
    // Verificar si el token ya está almacenado en el localStorage
    let storedToken = localStorage.getItem("fcmToken");
    console.log(storedToken);
    if (storedToken) {
      validate = true;
      resolve(storedToken);
    } else {
      // No se encontró el token en el almacenamiento local, solicitarlo
      if (localStorage.getItem("jwt_licencia")) {
        validate = false;

        // Verificar si las notificaciones están soportadas
        if (!("Notification" in window)) {
          reject(new Error("Este navegador no soporta notificaciones"));
          return;
        }

        // Verificar permisos existentes
        if (Notification.permission === "denied") {
          reject(
            new Error(
              "Los permisos de notificación están bloqueados. Debes habilitarlos manualmente en la configuración del navegador."
            )
          );
          return;
        }

        // Solicitar permisos usando la API moderna
        if (Notification.permission === "default") {
          Notification.requestPermission().then((permission) => {
            if (permission !== "granted") {
              reject(new Error("Permisos de notificación denegados"));
              return;
            }

            // Obtener token una vez que se conceden los permisos
            messaging
              .getToken()
              .then((token) => {
                localStorage.setItem("fcmToken", token);
                resolve(token);
              })
              .catch((error) => {
                reject(error);
              });
          });
        } else if (Notification.permission === "granted") {
          // Ya se tienen permisos, obtener token directamente
          messaging
            .getToken()
            .then((token) => {
              localStorage.setItem("fcmToken", token);
              resolve(token);
            })
            .catch((error) => {
              reject(error);
            });
        }
      } else {
        return validate;
      }
    }
  });
}

// Obtener el token de FCM
getFCMToken()
  .then((token) => {
    console.log(validate);
    if (validate) {
      console.log("Token ya obtenido FCM:", token);
      return token;
    } else {
      if (localStorage.getItem("jwt_licencia")) {
        const firebase = {
          email: JSON.parse(localStorage.getItem("jwt_user")).email,
          id_company: JSON.parse(localStorage.getItem("jwt_licencia"))
            .id_company,
          token: token,
        };
        axios
          .post(serverUrl + "/api/registerToken", firebase)
          .then((res) => {
            if (res.data.status == 200) {
              console.log("token de notificación registrado");
            }
            return res;
          })
          .catch((err) => {
            console.log("Error al registrar token de notificación:" + err);
            return err;
          });
      }
    }
  })
  .catch((error) => {
    console.error("Error al obtener el token de FCM:", error);
    return error;
  });

export { messaging };
